import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { appLayoutRoute } from '@/app/routes/roots';
import { validateTasksSearch } from './lib/tasksSearch';

/**
 * One route. The board, the list, every filter, the saved view and the open
 * task are search params (see lib/tasksSearch.ts), so a task link is
 * `/tasks?task=<id>` and opens over whatever board the recipient last had.
 */
export const tasksRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/tasks',
  component: lazyRouteComponent(() => import('./pages/TasksPage'), 'TasksPage'),
  validateSearch: validateTasksSearch,
});

export const tasksRoutes = [tasksRoute];
